import type { FcAdminTarget } from '@shared/fcAdminApiTypes';

const record = (value: unknown): Record<string, unknown> => value && typeof value === 'object' && !Array.isArray(value)
    ? value as Record<string, unknown>
    : {};

export const normalizeFcAdminTarget = (value: unknown, fallbackPublicId?: number): FcAdminTarget | undefined => {
    const candidate = record(value);
    const parsedPublicId = candidate.publicId ?? candidate.playerId ?? fallbackPublicId;
    const publicId = typeof parsedPublicId === 'number' ? parsedPublicId : Number(parsedPublicId);
    if (!Number.isSafeInteger(publicId) || publicId < 0) return undefined;
    const connectionGeneration = typeof candidate.connectionGeneration === 'string'
        && /^(?!00000000$)[a-f0-9]{8}$/.test(candidate.connectionGeneration)
        ? candidate.connectionGeneration
        : undefined;
    const characterRef = typeof candidate.characterRef === 'string'
        && /^offline:[a-f0-9]{64}$/.test(candidate.characterRef)
        ? candidate.characterRef
        : undefined;
    if (connectionGeneration) return { publicId, connectionGeneration };
    if (characterRef) return { publicId, characterRef };
    return undefined;
};

export const fcAdminTargetKey = (target: FcAdminTarget) => (
    `${target.publicId}:${target.connectionGeneration ?? target.characterRef ?? ''}`
);

export const isPlayerDossierActivationKey = (key: string) => key === 'Enter' || key === ' ';
